module.exports = "/images/mn.svg";